/**
 * Variables globales de la aplicación en local
 */


export const environment = {
  production: false,

  // URL del dominio asociado a la aplicación, para comprobar si está o no suspendido
  // domainUrl: 'http://192.168.0.75:8000',
  domainUrl: 'https://app.mensurlabquality.es/devxerintel/',
  // domainUrl: 'https://mensurlabquality.es/devxerintel/',

  // URL del endpoint de la api de pruebas
  // apiUrl: 'http://192.168.0.75:8000/api/auth/',
  apiUrl: 'https://app.mensurlabquality.es/devxerintel/api/auth/',

  // Sender id para las notificaciones push
  senderID: '543305643668',

  // Clave de stripe
  stripePublishableKey: 'pk_test_***************'
};
